<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1B3oOoX/images/Cover.jpg?1736996206506" alt="This image is the cover for the book Haunted Orlando, Haunted America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Haunted Orlando, Haunted America
      </h1>
      <p class="bookDescription body article font2">
        <p>Author Joshua Ginsberg guides intrepid readers on a journey into Orlando's haunted history. More than 70 million people visit Orlando annually. Some travel for pleasure, others come for business, but once the glow of the nightly fireworks over the Magic Kingdom fades, the City Beautiful plays host to a different set of guests…from beyond the grave. Do those who played roles in bringing the city to life continue to inhabit it well after their deaths? Encounter July Perry and the ghosts of Wall Street Square, the apparition known as the Lady of Lucerne, the unquiet victims of Sunland Hospital, restless residents of Greenwood Cemetery, and a great many others.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joshua Ginsberg
      </h2>
      
      <p class="authorDescription body article">Joshua Ginsberg is an author and curiosity seeker. He has written multiple local travel and history books, including Haunted Orlando (2024) and Secret Tampa Bay: A Guide to the Weird, Wonderful and Obscure (2020), and he coauthored Secret Orlando: A Guide to the Weird, Wonderful and Obscure (2023). His work has also appeared in print and digital publications such as Trembling with Fear (The Horror Tree), The Chamber Magazine , The City Key , 365 Tomorrows , Atlas Obscura , Travel After Five and on his own blog, Terra Incognita Americanus . He lives in Tampa with his wife, Jen, and their Shih Tzu, Tinker Bell.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2ba3cde9